import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import GlobalStyles from './styles/GlobalStyles';
import theme from './styles/Theme';

// Pages
import Home from './pages/Home';
import Entreprise from './pages/Entreprise';
import Techniques from './pages/Techniques';
import Realisations from './pages/Realisations';
import Blog from './pages/Blog';
import BlogDetails from './pages/BlogDetails';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';
import RealizationDetails from './pages/RealizationDetails';

// Pages Admin
import AdminLogin from './admin/AdminLogin';
import AdminManager from './admin/AdminManager';

// Components
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import ScrollToTop from './components/utils/ScrollToTop';
import authService from './services/auth';

// Route protégée pour l'administration
const ProtectedRoute = ({ children }) => {
  const isLoggedIn = authService.isLoggedIn();

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

// Layout pour les pages du site avec Header et Footer
const MainLayout = ({ children }) => {
  return (
    <>
      <Header />
      <main>{children}</main>
      <Footer />
    </>
  );
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <Router>
        <ScrollToTop />
        <Routes>
          {/* Routes Admin - sans Header/Footer */}
          <Route path="/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminManager />
              </ProtectedRoute>
            }
          />

          {/* Routes publiques - avec Header/Footer */}
          <Route
            path="/"
            element={
              <MainLayout>
                <Home />
              </MainLayout>
            }
          />
          <Route
            path="/entreprise"
            element={
              <MainLayout>
                <Entreprise />
              </MainLayout>
            }
          />
          <Route
            path="/techniques"
            element={
              <MainLayout>
                <Techniques />
              </MainLayout>
            }
          />
          <Route
            path="/realisations"
            element={
              <MainLayout>
                <Realisations />
              </MainLayout>
            }
          />
          <Route
            path="/realisations/:id"
            element={
              <MainLayout>
                <RealizationDetails />
              </MainLayout>
            }
          />
          <Route
            path="/blog"
            element={
              <MainLayout>
                <Blog />
              </MainLayout>
            }
          />
          <Route
            path="/blog/:slug"
            element={
              <MainLayout>
                <BlogDetails />
              </MainLayout>
            }
          />
          <Route
            path="/contact"
            element={
              <MainLayout>
                <Contact />
              </MainLayout>
            }
          />
          <Route
            path="*"
            element={
              <MainLayout>
                <NotFound />
              </MainLayout>
            }
          />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;